import { ICommerceInitialClickTrigger } from './types';
/**
 * Data team requested to sent click trigger only if it's not on product card
 * @param clickTrigger
 * @returns
 */
export const getClickTriggerPixelValue = (clickTrigger) => clickTrigger !== ICommerceInitialClickTrigger.PRODUCT_CARD
    ? clickTrigger
    : undefined;
